import React, { useState } from "react";
import { Icon } from "../../../../shared/Icon/Icon";

import { CustomerSettingsVariables } from "../../InsightsCard/Insights/Insights";
import { ServiceEmailModal } from "./ServiceEmailModal";

interface Props {
  handleEmailNotifications: ({
    errorReportingEmail,
    systemNotificationRecipientUserIds,
  }: CustomerSettingsVariables) => void;
  errorReportingEmail?: string;
  systemNotificationRecipientUserIds?: string[];
  loading: boolean;
  error?: Error;
}

export const ServiceEmail = ({
  handleEmailNotifications,
  errorReportingEmail,
  systemNotificationRecipientUserIds,
  loading,
  error,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="flex-a-center cursor-pointer"
        onClick={() => setIsOpen(true)}
      >
        <Icon icon="service-email" />
        <h3>Email notifications</h3>
      </div>

      {isOpen && (
        <ServiceEmailModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          email={errorReportingEmail}
          systemNotificationRecipientUserIds={
            systemNotificationRecipientUserIds
          }
          handleEmailNotifications={handleEmailNotifications}
          loading={loading}
          error={error}
        />
      )}
    </>
  );
};
